import { IQ_API_BASE_URL } from "./constants.js";
import { loadPageOnResolve, setPageLoadProgress } from "./script.js";
import { makeCompatibleStyles } from "./styles-helper.js";

document.addEventListener("DOMContentLoaded", function () {
  // Tab functionality
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      tabButtons.forEach((btn) => btn.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      button.classList.add("active");
      const tabId = button.getAttribute("data-tab");
      document.getElementById(tabId).classList.add("active");
    });
  });

  // map  button transition
  const buttons = document.querySelectorAll(".btn_map");
  const slider = document.querySelector(".map-slider");

  buttons.forEach((btn, index) => {
    btn.addEventListener("click", () => {
      // Remove present class from all buttons
      document.querySelector(".btn_map.present")?.classList.remove("present");
      btn.classList.add("present");

      // Move the slider
      updateSlider(index);

      // Switch the map and address
      changeMap(index);
    });
  });

  // Update the slider transform to use enhanced handling
  function updateSlider(index) {
    const transformValue = `translateX(${index * 100}%)`;
    const compatibleStyles = makeCompatibleStyles({
      transform: transformValue,
    });
    Object.assign(slider.style, compatibleStyles);
  }

  // Accordion functionality
  const accordionHeaders = document.querySelectorAll(".accordion-header");

  accordionHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      const content = header.nextElementSibling;
      const icon = header.querySelector("img, i");
      const isOpen = header.classList.contains("active");

      // Close all
      accordionHeaders.forEach((h) => {
        h.classList.remove("active");
        h.querySelector("img, i")?.classList.remove("rotate");
        const c = h.nextElementSibling;
        c.style.height = 0;
        c.classList.remove("active");
      });

      // Open if not already open
      if (!isOpen) {
        header.classList.add("active");
        content.classList.add("active");
        icon?.classList.add("rotate");

        // Smooth expand
        content.style.height = content.scrollHeight + "px";
      }
    });
  });

  // On page load, collapse all accordion contents

  document.querySelectorAll(".accordion-content").forEach((content) => {
    content.style.height = 0;
  });

  async function handleFormSubmit() {
    const name = document.getElementById("name").value.trim();
    const email = document.getElementById("email").value.trim();
    const phone = document.getElementById("phone").value.trim();
    const message = document.getElementById("message").value.trim();

    const nameRegex = /^[a-zA-Z\s]{1,}$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
    const phoneRegex = /^\+?[0-9\s\-]{7,}$/;

    if (!nameRegex.test(name)) {
      alert("Invalid name.");
      return;
    }

    if (!emailRegex.test(email)) {
      alert("Invalid email address.");
      return;
    }

    if (!phoneRegex.test(phone)) {
      alert(
        "Invalid phone number. Minimum 7 digits allowed, can include +, space, and hyphens."
      );
      return;
    }
    if (message.length === 0) {
      alert("Please enter a message");
      return;
    }
    const bookbutton = document.getElementById("bookButton");
    bookButton.disabled = true;

    bookButton.innerText = "loading...";

    try {
      const response = await fetch(
        `${IQ_API_BASE_URL}/iqtechmax/contact-sales`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name,
            email,
            phone,
            message,
          }),
        }
      );

      const result = await response.json();
      if (result.message === "MAIL_SENT_SUCCESSFULLY") {
        alert("Form submitted successfully");
      }
    } catch (err) {
      console.log(err.message);
    } finally {
      bookButton.disabled = false;
      bookButton.innerText = "Submit";
    }
  }

  const bookButton = document.getElementById("bookButton");
  bookButton.addEventListener("click", () => {
    handleFormSubmit();
  });

  function changeMap(index) {
    const allFrames = document.querySelectorAll(".map-frame");
    const allButtons = document.querySelectorAll(".btn_map");
    const addressTag = document.querySelectorAll(".address");

    allFrames.forEach((frame, i) => {
      frame.classList.toggle("active", i === index);
    });

    allButtons.forEach((btn, i) => {
      btn.classList.toggle("present", i === index);
    });

    addressTag.forEach((btn, i) => {
      btn.classList.toggle("active", i === index);
    });
  }

  function getCaseStudyDataFromURL() {
    const urlParams = new URLSearchParams(window.location.search);

    if (!urlParams.has("project")) {
      return null; // No case study data
    }

    return {
      project: urlParams.get("project"),
      domain: urlParams.get("domain"),
      problem: urlParams.get("problem"),
      solution: urlParams.get("solution"),
      impact: urlParams.get("impact"),
      id: urlParams.get("id"),
    };
  }

  function fillMessageFromQuery() {
    const caseStudyData = getCaseStudyDataFromURL();

    if (caseStudyData) {
      const messageTextarea = document.getElementById("message");

      if (messageTextarea) {
        const prefilledMessage = `Hi! I'm interested in learning more about the "${caseStudyData.project}" case study.`;

        messageTextarea.value = prefilledMessage;
      }
    }
  }

  async function loadIframe(iframe) {
    return await new Promise((res) => {
      iframe.src = iframe.dataset.src;
      iframe.addEventListener("load", res);
    });
  }

  fillMessageFromQuery();

  // map load on initial
  const loadMaps = async () => {
    const mapFrame = document.querySelectorAll(".map-frame");
    if (mapFrame) {
      for (let i = 0; i < mapFrame.length; i++) {
        await loadIframe(mapFrame[i]);
        await setPageLoadProgress(i * 15 + 15); // 15, 30, 45, 60
      }
    }
  };

  loadPageOnResolve(loadMaps);
});
